import { render, staticRenderFns } from "./ProductContentListItem.vue?vue&type=template&id=b6dd551c&scoped=true&"
import script from "./ProductContentListItem.vue?vue&type=script&lang=js&"
export * from "./ProductContentListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentListItem.vue?vue&type=style&index=0&id=b6dd551c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6dd551c",
  null
  
)

export default component.exports